<template>
  <v-main :class="(celebrationId || customerId) ? 'pa-0' : ''">
    <v-container fluid :class="(celebrationId) ? 'pa-0' : ''">
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Participantes</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
          <!-- <v-btn v-if="!celebrationId" text color="primary" @click="modalFilter = true">
            <v-icon left>mdi-filter-outline</v-icon> Filtrar
          </v-btn> -->
          <v-btn text color="primary" @click="editItem = { id: null, item: {}, show: true }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        loading-text="Carregando..."
        :loading="loading"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :server-items-length="pagination.total"
        :page.sync="pagination.page"
        :sort-by.sync="pagination.sortBy"
        :sort-desc.sync="pagination.sortDesc"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'participantDetails', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
          <v-btn @click="editItem = { id: item.id, item: item, show: true }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
         <template v-slot:item.customer.name="{ item }">
          {{ item.customer.name }}<br>({{ item.customer.nickname }})
        </template>
        <template v-slot:item.customer.phone_number="{ item }">
          {{ item.customer.phone_number | phone_number }}
        </template>
        <template v-slot:item.customer.person_document="{ item }">
          {{ item.customer.person_document | document }}
        </template>
        <template v-slot:item.role="{ item }">
          {{ item.role | role }}
        </template>
        <template v-slot:item.payment_day="{ item }">
          {{ (item.payment_day === 0) ? 'Último dia' : item.payment_day }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <filter-modal v-if="!celebrationId" :open="modalFilter" page="participants" title="Participantes" @close="modalFilter = false"></filter-modal>
    <edit-modal
      :id="editItem.id"
      :celebrationId="celebrationId"
      :customerId="customerId"
      :item="editItem.item"
      v-if="editItem.show"
      @canceled="editItem.show = false"
      @error="editItem.show = false"
      @edited="editItem.show = false; getData()"
    ></edit-modal>
  </v-main>
</template>

<script>
import axios from 'axios'
import FilterModal from '@/components/FilterModal'
import Quicksearch from '@/components/Quicksearch'
import EditModal from '@/components/EditModals/Participant'
import { mapGetters } from 'vuex'

export default {
  name: 'participants',
  components: {
    Quicksearch,
    FilterModal,
    EditModal
  },
  props: ['celebrationId', 'customerId'],
  data () {
    let customHeaders

    if (this.celebrationId) {
      customHeaders = [
        {
          text: 'Nome',
          value: 'customer.name'
        },
        {
          text: 'E-mail',
          value: 'customer.email'
        },
        {
          text: 'Telefone',
          value: 'customer.phone_number'
        },
        {
          text: 'CPF/CNPJ',
          value: 'customer.person_document'
        }
      ]
    }

    if (this.customerId) {
      customHeaders = [
        {
          text: 'Turma',
          value: 'celebration.name'
        }
      ]
    }

    return {
      loading: false,
      modalFilter: false,
      quicksearch: '',
      items: [],
      headers: [
        {
          text: '',
          sortable: false,
          value: 'actions',
          width: 115
        },
        ...customHeaders,
        {
          text: 'Papel',
          value: 'role'
        },
        {
          text: 'Dia de pagamento',
          value: 'payment_day'
        },
        {
          text: 'Entrou em',
          value: 'created_at'
        }
      ],
      pagination: {
        rowsPerPage: 20,
        page: 1,
        total: 0,
        sortBy: [],
        sortDesc: []
      },
      editItem: {
        item: {},
        id: null,
        show: false
      }
    }
  },
  computed: {
    ...mapGetters(['searchParams']),
    noResultText () {
      return 'Nenhum participante cadastrado'
    },
    params () {
      let params = '?page[size]=' + this.pagination.rowsPerPage + '&page[number]=' + this.pagination.page
      if (this.quicksearch.length > 0) params += '&filter[q]=' + this.quicksearch
      if (this.celebrationId) params += '&filter[celebration_id]=' + this.celebrationId
      if (this.customerId) params += '&filter[customer_id]=' + this.customerId
      for (let key in this.searchParams('participants')) {
        if (this.searchParams('participants')[key]) {
          if (Array.isArray(this.searchParams('participants')[key])) params += '&filter[' + key + ']=' + this.searchParams('participants')[key].join()
          else params += '&filter[' + key + ']=' + this.searchParams('participants')[key]
        }
      }
      for (let i = 0, l = this.pagination.sortBy.length; i < l; i++) {
        if (i === 0) params += '&sort='
        else params += ','
        if (this.pagination.sortDesc[i]) params += '-'
        params += this.pagination.sortBy[i]
      }
      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    getData () {
      let vue = this
      vue.loading = true

      axios.get('participants' + vue.params)
        .then(response => {
          vue.items = response.data.data
          vue.loading = false
          vue.pagination.total = response.data.meta.total
        })
        .catch(() => {
          vue.loading = false
          vue.items = []
          vue.pagination.total = 0
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
